import WurldCheckbox from './Fields/WurldCheckbox.vue';
import WurldInput from './Fields/WurldInput.vue';
import WurldRadioButton from './Fields/WurldRadioButton.vue';
import WurldSelect from './Fields/WurldSelect.vue';
import WurldTextarea from './Fields/WurldTextarea.vue';

export default {
	WurldCheckbox,
	WurldInput,
	WurldRadioButton,
	WurldSelect,
	WurldTextarea
};
